import angular from 'angular';
import {
  parseGeneratedCodeFormat,
  generateGeneratedCodeExample,
} from '@/shared/utils/generatedCodeFormat';

export { parseGeneratedCodeFormat, generateGeneratedCodeExample };

angular.module('cloudX').directive('cxGeneratedCodeFormat', [
  function() {
    return {
      restrict: 'E',
      template: require('./generatedCodeFormat.html'),
      scope: {
        data: '=',
        submit: '&',
        cancel: '&',
        firstNumber: '=',
        showWarning: '=',
      },
      controller: [
        '$scope',
        '$q',
        function($scope, $q) {
          $scope.editMode = false;
          $scope.elements = [];
          $scope.saving = false;

          $scope.parts = [
            { id: 'Counter', n: 0 },
            { id: 'Text', t: '' },
          ];
          $scope.addPart = function(nr) {
            if (nr !== 0 || !$scope.hasCounter())
              $scope.elements.push(angular.copy($scope.parts[nr]));
          };

          $scope.startEdit = function() {
            $scope.editMode = true;
            $scope.elements = parseGeneratedCodeFormat($scope.data);
          };
          $scope.dragIndex = null;
          $scope.startDrag = function(e, ui, index) {
            $scope.dragIndex = index;
          };
          $scope.stopDrag = function() {
            $scope.dragIndex = null;
          };
          $scope.dragOver = function(e, ui, index) {
            var dropEl = $(e.target);
            dropEl.removeClass('drop-left').removeClass('drop-right');
            if ($scope.dragIndex == null) return;
            if ($scope.dragIndex < index) dropEl.addClass('drop-right');
            if ($scope.dragIndex > index) dropEl.addClass('drop-left');
          };
          $scope.hasCounter = function() {
            return (
              $scope.elements.findIndex(function(el) {
                return el.id === 'Counter';
              }) >= 0
            );
          };

          $scope.example = function() {
            if (!$scope.editMode)
              return generateGeneratedCodeExample($scope.data);
            return generateGeneratedCodeExample($scope.elements);
          };
          $scope.firstNumberExample = function() {
            if (!$scope.editMode)
              return generateGeneratedCodeExample($scope.data, $scope.firstNumber);
            return generateGeneratedCodeExample($scope.elements, $scope.firstNumber);
          };

          $scope.cancelEdit = function() {
            $scope.editMode = false;
            $scope.cancel();
          };
          $scope.clear = function() {
            $scope.elements = [];
          };
          $scope.save = function() {
            var result = $scope.elements.reduce(function(result, el) {
              if (el.id === 'Text') return result + el.t;
              if (el.id === 'Counter') return result + ('[Counter:N' + (el.n || '0') + ']');
              return result;
            }, '');

            $scope.saving = true;
            return $q.when($scope.submit({ newVal: result })).then(
              function(success) {
                $scope.saving = false;
                //Error. Local model will not be updated, form will not close
                if (typeof success === 'string') return;

                //Success. Local model will be updated automatically
                if (typeof success === 'undefined' || !!success) $scope.data = result;

                //Form will close
                $scope.editMode = false;
              },
              error => {
                $scope.saving = false;
              },
            );
          };
        },
      ],
    };
  },
]);

